// Import React and useState hook
import React, { useState } from "react";

// Home component allows user to enter topic or select default
// Props:
// - this is  function from App.js to start the quiz
function Home({ startQuiz }) {
  // Store user input for topic 
  const [topicInput, setTopicInput] = useState("");

  // Allowed topics (Open Trivia DB categories) 
  const topics = ["General", "Science", "Math", "History", "Sports"];

  // Handle input change event
  const handleChange = (e) => {
    setTopicInput(e.target.value);
  };

  // Handle Start Quiz button
  const handleStart = () => {
    if (topicInput.trim() === "") {
      alert("Please enter a topic"); // Alert if input is empty
      return;
    }

    // Make input case-insensitive
    const inputTopic = topicInput.trim().toLowerCase();

    // Check if input matches allowed topics
    const matchedTopic = topics.find(
      (t) => t.toLowerCase() === inputTopic
    );

    if (matchedTopic) {
      startQuiz(matchedTopic); // Start quiz with valid topic
      setTopicInput("");        // Reset input field
    } else {
      // Alert if topic not available
      alert(
        `Sorry, we don't have questions for  "${topicInput}" please try again later `
      );
    }
  };

  return (
    <div className="container mt-5">
      <h2>Welcome to the Quiz App</h2>
      <p>Enter a topic of your choice or select a default topic:</p>

      {/* Input field for typing topic */}
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Enter any Subject from below "
        value={topicInput}
        onChange={handleChange}
      />

      {/* Start Quiz button */}
      <button className="btn btn-primary" onClick={handleStart}>
        Start Quiz
      </button>

      <hr />

      {/* Default topic buttons */}
      <p>Or select a default topic:</p>
      <div className="d-flex gap-2 flex-wrap">
        {topics.map((t, index) => (
          <button
            key={index}
            className="btn btn-outline-secondary"
            onClick={() => startQuiz(t)} // Start quiz immediately for button topic
          >
            {t}
          </button>
        ))}
      </div>
    </div>
  );
}

// Export Home component for App.js
export default Home;
